import React, { useRef } from 'react';
import clsx from 'clsx';
import { Box, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import Button from '../form/elements/Button';
import { BUTTON_VARIANT } from '../form/enum/formProps';
import { VOTE_OPTIONS } from '../../features/article/ArticleShow/enums/voteOptions';
import CollapseInfo from './CollapseInfo/CollapseInfo';
import './survey.scss';
const Survey = () => {
  const { t } = useTranslation();
  const [ans, setAns] = React.useState('');

  const voteSection = useRef(null);
  const scrollToSection = (elementRef: any) => {
    window.scrollTo({
      top: elementRef.current.offsetTop,
      behavior: 'smooth',
    });
  };
  const handleClick = (value: string) => {
    scrollToSection(voteSection);
    setAns(value);
  };
  const isVoteSet = (value: string) => {
    return ans !== '' && value === ans;
  };
  const handleOnSelect = () => {
    setAns(VOTE_OPTIONS.NO);
  };
  const handleOnTimeout = () => {
    setAns('');
  };
  const classVoteYes = clsx({
    active: isVoteSet(VOTE_OPTIONS.YES),
    is_helpful_vote_yes: true,
  });
  const classVoteNo = clsx({
    active: isVoteSet(VOTE_OPTIONS.NO) || isVoteSet(VOTE_OPTIONS.NO_INFO),
    is_helpful_vote_no: true,
  });

  return (
    <>
      <section className="Survey" ref={voteSection}>
        <Typography variant="h6">{t('article.is_helpful')}</Typography>
        <Box mt={3} display="flex" flexDirection="row" alignContent="center" gridGap={24}>
          <Button
            text={t('article.yes')}
            variant={BUTTON_VARIANT.OUTLINED}
            onClick={() => handleClick(VOTE_OPTIONS.YES)}
            disabled={isVoteSet(VOTE_OPTIONS.YES)}
            className={classVoteYes}
          />
          <Button
            text={t('article.no')}
            variant={BUTTON_VARIANT.OUTLINED}
            onClick={() => handleClick(VOTE_OPTIONS.NO_INFO)}
            disabled={isVoteSet(VOTE_OPTIONS.NO) || isVoteSet(VOTE_OPTIONS.NO_INFO)}
            className={classVoteNo}
          />
        </Box>
        <CollapseInfo className="Survey-Info" open={ans} onTimeout={handleOnTimeout} onSelect={handleOnSelect} />
      </section>
    </>
  );
};

export default Survey;
